import React, { Component, lazy } from 'react';
import { Switch } from 'react-router-dom';

import { RouteWrapper } from 'components/layout/helper';
import { ROUTES, PAGE_VIEW_EVENTS } from 'configs/routes/constants';
import withSuspense from 'hoc/withSuspense';

const BroadcastNew = lazy(() => import('./broadcastNew/BroadcastNew'));
const BroadcastManager = lazy(() => import('./BroadcastManager'));

class BroadcastManagerIndex extends Component {
  render() {
    return (
      <Switch>
        <RouteWrapper
          path={ROUTES.BROADCAST.NEW}
          track={PAGE_VIEW_EVENTS.BROADCAST.NEW}
          render={withSuspense(BroadcastNew)}
        />
        <RouteWrapper
          path={ROUTES.BROADCAST.LIST}
          track={PAGE_VIEW_EVENTS.BROADCAST.MAIN}
          render={withSuspense(BroadcastManager)}
        />
      </Switch>
    );
  }
}

export default BroadcastManagerIndex;
